import {NgModule} from '@angular/core';
import {RouterModule} from "@angular/router";
import {CATALOG_ROUTES} from "./catalog.routes";

@NgModule({
    imports: [
        RouterModule.forChild(CATALOG_ROUTES),
    ],
    exports: [
        RouterModule
    ]
})
export class CatalogRoutingModule { }
